import React, { useCallback, useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import "./multiRangeSlider.css";
import useIsMobile from "../../../hooks/useIsMobile";

const MultiRangeSlider = (props) => {
  const { isMobile } = useIsMobile();
  const [minDisplayed, setMinDisplayed] = useState(props.constraints.min);
  const [maxDisplayed, setMaxDisplayed] = useState(props.constraints.max);
  const { min, max } = props.constraints;
  const [minVal, setMinVal] = useState(props.startingValue.min);
  const [maxVal, setMaxVal] = useState(props.startingValue.max);
  const minValRef = useRef(props.startingValue.min);
  const maxValRef = useRef(props.startingValue.max);
  const range = useRef(null);
  const { isToggled, toggle } = props.others.resetFiltersToggler;

  const onChange = ({ min, max }) => {
    props.setValue(`${props.name}_min `, min);
    setMinDisplayed(min);
    props.setValue(`${props.name}_max `, max);
    setMaxDisplayed(max);
  };

  // Convert to percentage
  const getPercent = useCallback(
    (value) => Math.round(((value - min) / (max - min)) * 100),
    [min, max]
  );

  // Set width of the range to decrease from the left side
  useEffect(() => {
    const minPercent = getPercent(minVal);
    const maxPercent = getPercent(maxValRef.current);

    if (range.current) {
      range.current.style.left = `${minPercent}%`;
      range.current.style.width = `${maxPercent - minPercent}%`;
    }
  }, [minVal, getPercent]);

  // Set width of the range to decrease from the right side
  useEffect(() => {
    const minPercent = getPercent(minValRef.current);
    const maxPercent = getPercent(maxVal);

    if (range.current) {
      range.current.style.width = `${maxPercent - minPercent}%`;
    }
  }, [maxVal, getPercent]);

  // Get min and max values when their state changes
  useEffect(() => {
    if (isToggled) {
      setMinVal(props.constraints.min);
      props.setValue(`${props.name}_min `, props.constraints.min);
      setMinDisplayed(min);
      setMaxVal(props.constraints.max);
      props.setValue(`${props.name}_max `, props.constraints.max);
      setMaxDisplayed(max);
      toggle();
    } else if (isToggled === false) {
      onChange({ min: minVal, max: maxVal });
    }
  }, [minVal, maxVal, onChange, isToggled]);

  return (
    <div
      className={`customInput-rangeSlider-box`}
      style={{
        width: `${props.width}px`,
      }}
    >
      <p className="customInput-rangeSlider-title">{props.title}</p>
      <div className="customInput-rangeSlider-input-box">
        <p className="customInput-rangeSlider-input-values">
          {minDisplayed === props.constraints.min ? "ALL" : minDisplayed}-
          {maxDisplayed === props.constraints.max ? "ALL" : maxDisplayed}
        </p>
        <div>
          <input
            type="range"
            min={min}
            max={max}
            value={minVal}
            onChange={(event) => {
              const value = Math.min(Number(event.target.value), maxVal - 1);
              setMinVal(value);
              minValRef.current = value;
            }}
            className="thumb thumb--left"
            style={{
              zIndex: `calc(${minVal > max - 100 && "5"})`,
              width: isMobile ? "300px" : "170px",
            }}
          />
          <input
            type="range"
            min={min}
            max={max}
            value={maxVal}
            onChange={(event) => {
              const value = Math.max(Number(event.target.value), minVal + 1);
              setMaxVal(value);
              maxValRef.current = value;
            }}
            className="thumb thumb--right"
            style={{
              width: isMobile ? "300px" : "170px",
            }}
          />
          <div
            className="my-slider"
            style={{ width: isMobile ? "300px" : "170" }}
          >
            <div className="my-slider__track" />
            <div ref={range} className="my-slider__range" />
          </div>
        </div>
      </div>
    </div>
  );
};
/* 
MultiRangeSlider.propTypes = {
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
}; */

export default MultiRangeSlider;
